export default "__VITE_ASSET__2c31baaa__"